import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TrOverlayInputComponent } from './tr-overlay-input.component';
import { TrMoneyModule } from '../tr-forms-inputs/tr-money/tr-money.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TrMoneyModule,
    ],
    exports: [ TrOverlayInputComponent ],
    declarations: [ TrOverlayInputComponent ],
    entryComponents: [ TrOverlayInputComponent ],
})
export class TrOverlayInputModule {}
